import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
/* commented by Bill J. - use js service worker
import * as serviceWorker from './serviceWorker';
*/

require('dotenv').config();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
/* commented by Bill J. - use js service worker
serviceWorker.unregister();
*/
